import { useEffect } from 'react'

export interface Opts {
  onAction: () => void
}

function useOnUserAction({ onAction }: Opts) {
  useEffect(function subscribe() {
    window.addEventListener('keydown', onAction)
    window.addEventListener('mousemove', onAction)
    return () => {
      window.removeEventListener('keydown', onAction)
      window.removeEventListener('mousemove', onAction)
    }
  }, [onAction])
}

export default useOnUserAction
